module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"SummaryCostData\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/summary-cost-data/summary-cost-data.component.html
// module id = ./src/app/summary-cost-data/summary-cost-data.component.html
// module chunks = main